<template>
  <div class="home_postgraduate_box" v-if="postgraduateChatList">
    <div class="content">
      <div class="hotClass">
        <p>考研咨询专区</p>
        <span>免费解答，定制学习计划</span>
      </div>
      <div class="load" v-if="showEmpty">
        <van-skeleton v-for="(item, k) in 3" :key="k" avatar row="0" avatar-size="48" />
      </div>
      <div class="chatSwiper" v-else>
        <img
          @click="openAdvisory(item.skipUrl, item,index)"
          v-for="(item, index) in postgraduateChatList"
          :key="index"
          :src="item.images"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { gioPlatform,gioJumpType } from '@/utils/tools';

export default {
  props: {
    postgraduateChatList: {
      type: Array,
    },
    examYear: {
      // 考研年份
      type: [Number, String],
      default: 23,
    },
  },
  data() {
    return {
      showEmpty: true,
    };
  },
  watch: {
    postgraduateChatList() {
      this.showEmpty = false;
      if (!this.postgraduateChatList?.length) return;
      gio('track', 'adShown_event', {
        adPosition_var: `${this.examYear}考研-首页-咨询专区`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: 0, // 广告序号
        adId_var: this.postgraduateChatList[0]?.id.toString(), // 广告ID
        adName_var: this.postgraduateChatList[0]?.title.toString(), // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: '', // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
  methods: {
    openAdvisory(url, item, index) {
      this.openUrl(url);
      gio('track', 'adClick_event', {
        adPosition_var: `${this.examYear}考研-首页-咨询专区`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: index, // 广告序号
        adId_var: item?.id.toString(), // 广告ID
        adName_var: item?.title, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: gioJumpType(item.skipType), // 跳转类型
        platform_var: gioPlatform(),
      });
    },
    openUrl(url) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.home_postgraduate_box {
  padding-top: 30px;
  background: #f8f8f8;
  .content {
    padding: 30px;
    background: linear-gradient(180deg, #fffaf5 0%, #fff4e8 100%);
    .hotClass {
      p {
        color: $fontColorBlack;
        font-weight: bold;
        font-size: 32px;
      }
      span {
        color: #666;
        font-weight: 400;
        font-size: 24px;
      }
    }
    .chatSwiper {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      margin-top: 24px;
      overflow: auto;
      img {
        width: 324px;
        height: 324px;
        margin-right: 10px;
        border-radius: 10px;
      }
    }
    .chatSwiper::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
